const CATALOG_URL = 'https://modlink-production.s3.us-east-2.amazonaws.com/catalogs/2026+Modlink+Expo+Catalogue.pdf';

export const CatalogPage = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="bg-[url(/assets/images/Background.png)] bg-center bg-cover bg-no-repeat relative w-full h-[160px] sm:h-[200px] md:h-[220px]">
        <div className="container relative h-full flex flex-col justify-center items-center mx-auto px-4 z-10">
          <div className="font-displayed !font-normal text-4xl sm:text-5xl lg:text-6xl text-white tracking-wider text-center">
            CATALOG
          </div>
        </div>
      </section>

      {/* PDF Viewer Section */}
      <section className="w-full bg-first-dark-gray py-8 md:py-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
            <div className="font-displayed !font-normal text-orangicide text-2xl sm:text-3xl md:text-4xl tracking-wider text-center md:text-left">
              2026 EXPO CATALOG
            </div>
            <a
              href={CATALOG_URL}
              download
              target="_blank"
              rel="noopener noreferrer"
              className="btn-orangicide font-displayed !font-normal text-lg sm:text-xl md:text-2xl w-full sm:w-auto sm:max-w-xs md:w-72 px-6 py-3 md:py-4 tracking-wider cursor-pointer text-center"
            >
              DOWNLOAD PDF
            </a>
          </div>

          <div
            className="w-full bg-black overflow-hidden h-[60vh] sm:h-[70vh] md:h-auto"
            style={{ aspectRatio: 'auto' }}
          >
            <iframe
              src={CATALOG_URL}
              title="Modlink Catalog"
              className="w-full h-full md:h-[80vh]"
            />
          </div>
        </div>
      </section>
    </>
  );
};
